import { render } from "./quote-icons.vue?vue&type=template&id=1e3415c6"
import script from "./quote-icons.vue?vue&type=script&lang=js"
export * from "./quote-icons.vue?vue&type=script&lang=js"

import "./quote-icons.vue?vue&type=style&index=0&id=1e3415c6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__